import { DisplayPosition } from '@/common/manager/position/display-position';
import { UploadCom } from '../components/upload';
import { handleRequestParams, handleResultProcessFunc, transRequestConfigToRemote, } from '@/common/util/request';
import { getRealRequestUrl, setAdvancedConfigToProps, handleRequestExtraConfig, } from '@/common/util/util';
export const config = {
    position: [
        DisplayPosition.form,
        DisplayPosition.formDialog,
        DisplayPosition.cnArrayTable,
        DisplayPosition.cnArraySubAreaCard,
    ],
    componentName: 'Upload',
    component: UploadCom,
    formComponent: UploadCom,
    formItemBeforeHandler: (formItem, config) => {
        const { state, formValue, urlParams, formProps } = config;
        if (formItem) {
            const componentProps = formItem['x-component-props'];
            if (componentProps) {
                const { uploadProps, webOfficeEnable, webOfficeEditRequestConfig, webOfficePreviewRequestConfig, } = componentProps;
                if (uploadProps && Array.isArray(uploadProps.accept)) {
                    uploadProps.accept = uploadProps.accept.join(',');
                }
                if (webOfficeEnable === true) {
                    componentProps.webOfficeEditRequestConfig =
                        transRequestConfigToRemote({
                            requestConfig: webOfficeEditRequestConfig,
                            urlParamsDataSource: urlParams,
                            recordDataSource: formValue,
                            state,
                        });
                    componentProps.webOfficePreviewRequestConfig =
                        transRequestConfigToRemote({
                            requestConfig: webOfficePreviewRequestConfig,
                            urlParamsDataSource: urlParams,
                            recordDataSource: formValue,
                            state,
                        });
                }
                else {
                    delete componentProps.webOfficeEditRequestConfig;
                    delete componentProps.webOfficePreviewRequestConfig;
                }
                if (componentProps.requestConfig) {
                    handleRequestExtraConfig(componentProps.requestConfig, state);
                    const { method, serviceType, params, resultProcessFunc, headers, __extraConfig__, } = componentProps.requestConfig;
                    const url = getRealRequestUrl({
                        requestConfig: componentProps.requestConfig,
                        state,
                    });
                    if (url) {
                        const requestConfig = { url, headers };
                        const { withCredentials } = __extraConfig__ || {};
                        if (withCredentials === true) {
                            requestConfig.withCredentials = true;
                            // 2023.3.23 文件上传组件升级后，获取凭证和推送文件两个请求拆分为两个requestConfig
                            componentProps.ossUploadConfig = { withCredentials: true };
                        }
                        if (serviceType === 'mokelay') {
                            requestConfig.method = 'post';
                        }
                        else if (method) {
                            requestConfig.method = method;
                        }
                        requestConfig.formatParam = (oldParams) => {
                            const realParams = handleRequestParams(params, {
                                urlParamsDataSource: urlParams,
                                recordDataSource: formValue,
                                state,
                            });
                            return {
                                ...oldParams,
                                ...realParams,
                            };
                        };
                        if (typeof resultProcessFunc === 'function') {
                            requestConfig.formatResult = handleResultProcessFunc(componentProps.requestConfig);
                        }
                        componentProps.requestConfig = requestConfig;
                    }
                }
                setAdvancedConfigToProps(componentProps);
                formItem['x-component-props'] = {
                    _dataSourceName: formProps?._dataSourceName,
                    ...componentProps,
                    ...uploadProps,
                };
            }
        }
    },
};
